import { get } from 'lodash-es';
import jwtDecode from 'jwt-decode';
import { getItem } from 'modules/v2/utils/legacy';

export const getValueFromToken = (value) => {
  const tokenData = getItem('token', 'string');

  if (tokenData) {
    const decodedData = jwtDecode(tokenData);
    return get(decodedData, ['data', value], false);
  }

  return false;
};

/**
 * Reads a claim from the token as it is, without a default: `undefined` when
 * there is no token or the claim is absent. Lets callers tell "absent" apart
 * from an explicit `false`.
 */
export const getRawClaim = (name) => {
  const tokenData = getItem('token', 'string');

  if (tokenData) {
    return get(jwtDecode(tokenData), ['data', name]);
  }

  return undefined;
};
